import { route } from 'quasar/wrappers'
import { createRouter, createMemoryHistory, createWebHistory, createWebHashHistory } from 'vue-router'
import routes from './routes'
import { publicData } from '../stores/publicData';
import { getCookie } from '../js/getCookie';
import { decrypt } from '../js/decrypt';
import { information_PAS } from '../js/network/information_PAS';
import { information_loanRecords } from '../js/network/information_loanRecords';
import { information_tasksManagement } from '../js/network/information_tasksManagement';
import { downloadBulletinInfos } from '../js/network/downloadBulletinInfos';
import { information_qualityManagement } from '../js/network/information_qualityManagement';
import { information_closedLoopManagement } from '../js/network/information_closedLoopManagement';

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

export default route(function (/* { store, ssrContext } */)
{
    const createHistory = process.env.SERVER ? createMemoryHistory : (process.env.VUE_ROUTER_MODE === 'history' ? createWebHistory : createWebHashHistory)

    const Router = createRouter(
    {
        scrollBehavior: () => ({ left: 0, top: 0 }),
        routes,

        // Leave this as is and make changes in quasar.conf.js instead!
        // quasar.conf.js -> build -> vueRouterMode
        // quasar.conf.js -> build -> publicPath
        history: createHistory(process.env.VUE_ROUTER_BASE)
    });

    Router.beforeEach(async (to, from, next) =>
    {        
        if(to.path == '/login')
        {
            next();
        }
        else
        {
            if(publicData().userName == "" || publicData().password == "")
            {
                if(getCookie("userName") == null || getCookie("password") == null)
                {
                    next("/login");
                }
                else
                {
                    publicData().userName = decrypt(getCookie("userName"));
                    publicData().password = decrypt(getCookie("password"));
                    publicData().name = getCookie("name");
                    publicData().department = getCookie("department");
                    publicData().jobPosition = getCookie("jobPosition");
                    publicData().manager = getCookie("manager");

                    if(publicData().department === "线路电气处(借调)")
                    {
                      publicData().information_tasksManagement = await information_tasksManagement(publicData().userName, publicData().password);
                      publicData().bulletinInfos_original = await downloadBulletinInfos(publicData().userName, publicData().password);
                      publicData().bulletinInfos_search = JSON.parse(JSON.stringify(publicData().bulletinInfos_original));
                    }
                    else if(publicData().department === "线路电气处")
                    {
                      publicData().information_PAS = await information_PAS(publicData().userName, publicData().password);
                      publicData().information_loanRecords = await information_loanRecords(publicData().userName, publicData().password);
                      publicData().information_tasksManagement = await information_tasksManagement(publicData().userName, publicData().password);
                      publicData().bulletinInfos_original = await downloadBulletinInfos(publicData().userName, publicData().password);
                      publicData().bulletinInfos_search = JSON.parse(JSON.stringify(publicData().bulletinInfos_original));
                      publicData().information_qualityManagement = await information_qualityManagement(publicData().userName, publicData().password);
                      publicData().information_closedLoopManagement = await information_closedLoopManagement(publicData().userName, publicData().password);
                    }
                    else
                    {
                        publicData().bulletinInfos_original = await downloadBulletinInfos(publicData().userName, publicData().password);
                        publicData().bulletinInfos_search = JSON.parse(JSON.stringify(publicData().bulletinInfos_original));
                    }

                    next();
                }
            }
            else
            {
                if(publicData().department === "线路电气处(借调)")
                {
                  publicData().information_tasksManagement = await information_tasksManagement(publicData().userName, publicData().password);
                  publicData().bulletinInfos_original = await downloadBulletinInfos(publicData().userName, publicData().password);
                  publicData().bulletinInfos_search = JSON.parse(JSON.stringify(publicData().bulletinInfos_original));
                }
                else if(publicData().department === "线路电气处")
                {
                  publicData().information_PAS = await information_PAS(publicData().userName, publicData().password);
                  publicData().information_loanRecords = await information_loanRecords(publicData().userName, publicData().password);
                  publicData().information_tasksManagement = await information_tasksManagement(publicData().userName, publicData().password);
                  publicData().bulletinInfos_original = await downloadBulletinInfos(publicData().userName, publicData().password);
                  publicData().bulletinInfos_search = JSON.parse(JSON.stringify(publicData().bulletinInfos_original));
                  publicData().information_qualityManagement = await information_qualityManagement(publicData().userName, publicData().password);
                  publicData().information_closedLoopManagement = await information_closedLoopManagement(publicData().userName, publicData().password);
                }
                else
                {
                    publicData().bulletinInfos_original = await downloadBulletinInfos(publicData().userName, publicData().password);
                    publicData().bulletinInfos_search = JSON.parse(JSON.stringify(publicData().bulletinInfos_original));
                }

                next();
            }
        }
    });

    return Router
})
